import * as angular from 'angular';
import { IExportToPdfService } from '../../services';
import { ComponentDefinition, PdfExportConfiguration } from '../../models';

class WtExportToPdfController implements angular.IComponentController {
    hasRoles: boolean;

    readonly configuration: PdfExportConfiguration;

    static $inject = [
        '$translate',
        'exportToPdfService'
    ];

    constructor(
        private _$translate: angular.translate.ITranslateService,
        private _exportToPdfService: IExportToPdfService
    ) {
    }

    export() {
        this._exportToPdfService
            .print(this.configuration, this._$translate.use());
    }
}

export const WtExportToPdf: ComponentDefinition = {
    componentId: 'wtExportToPdf',
    template: require('./exportToPdf.component.html'),
    controller: WtExportToPdfController,
    controllerAs: 'vm',
    bindings: {
        configuration: '<',
        isDisabled: '=?',
        isSmall: '='
    }
};